import { ClienteSegmento } from '../generated/backend-enums.js';
export { ClienteSegmento };
export const ClienteSegmentoMap = {
    [ClienteSegmento.ALIMENTOS_BEBIDAS]: 'Alimentos & Bebidas',
    [ClienteSegmento.VAREJO]: 'Varejo',
    [ClienteSegmento.SAUDE_BELEZA]: 'Saúde & Beleza',
    [ClienteSegmento.TECNOLOGIA]: 'Tecnologia',
    [ClienteSegmento.AUTOMOTIVO]: 'Automotivo',
    [ClienteSegmento.SERVICOS_FINANCEIROS]: 'Serviços Financeiros',
    [ClienteSegmento.OUTROS]: 'Outros',
};
